/**
 * @module Sagas/Pages
 */
import { put, takeEvery, takeLatest } from 'redux-saga/effects'

import { toast } from 'react-toastify';

import { ActionTypes } from 'constants/index';
import { JobService } from 'modules/api/index';

async function fetchAsync(func, arg) {
    const response = arg ? await func(arg) : await func();
    return response;
}

function* saveJob(action) {
    try {
        let response = yield fetchAsync(JobService.saveJob, action.payload);
        if (response) {
            response = JSON.parse(JSON.stringify(response))
            console.log("it is response =======", response)
            if (response?.status && response.response) response = response.response
            if (response.error && response.error !== '0') {
                let message = "Something wrong while saving data"
                if(response.data?.details?.details?.error?.message) {
                    message = response.data?.details?.details?.error?.message
                }
                toast.error(message)
                yield put({
                    type: ActionTypes.SAVE_JOB_FAILURE,
                    payload: { ...response, dataUniqueId: action?.payload?.dataUniqueId }
                });
            } else {
                toast.success(response?.data?.message || 'Data saved successfully')
                yield put({
                    type: ActionTypes.SAVE_JOB_SUCCESS,
                    payload: { data: response?.data, dataUniqueId: action?.payload?.dataUniqueId }
                });
            }
        }
    } catch (e) {
        conosle.log("it is error in save job ===", e);
        toast.error("Something wrong while saving data")
        yield put({
            type: ActionTypes.SAVE_JOB_FAILURE,
            payload: {
                error: e.message, dataUniqueId: action?.payload?.dataUniqueId
            }
        });
    }
}

function* getJob(action) {
    try {
        let response = yield fetchAsync(JobService.getJob, action.payload.data);
        if (response) {
            response = JSON.parse(JSON.stringify(response))
            console.log("it is response =======", response)
            if (response?.status && response.response) response = response.response
            if (response.error && response.error !== '0') {
                toast.error("No data found")
                yield put({
                    type: ActionTypes.GET_JOB_FAILURE,
                    payload: { ...response, dataUniqueId: action?.payload?.dataUniqueId }
                });
            } else {
                yield put({
                    type: ActionTypes.GET_JOB_SUCCESS,
                    payload: { data: response?.data, dataUniqueId: action?.payload?.dataUniqueId }
                });
            }
        }
    } catch (e) {
        console.log("it is error in get job ===", e);
        toast.error("No data found")
        yield put({
            type: ActionTypes.GET_JOB_FAILURE,
            payload: {
                error: e.message, dataUniqueId: action?.payload?.dataUniqueId
            }
        });
    }
}

function* executeJob(action) {
    try {
        let response = yield fetchAsync(JobService.executeJob, action.payload);
        if (response) {
            response = JSON.parse(JSON.stringify(response))
            console.log("it is response =======", response)
            if (response?.status && response.response) response = response.response
            if (response.error && response.error !== '0') {
                toast.error("Something wrong while executing the job")
                yield put({
                    type: ActionTypes.EXECUTE_JOB_FAILURE,
                    payload: { ...response, dataUniqueId: action?.payload?.dataUniqueId }
                });
            } else {
                toast.success(response?.data?.message || 'Executed successfully')
                yield put({
                    type: ActionTypes.EXECUTE_JOB_SUCCESS,
                    payload: { data: response?.data, dataUniqueId: action?.payload?.dataUniqueId }
                });
            }
        }
    } catch (e) {
        console.log("it is error in execute job ===", e);
        toast.error("Something wrong while executing the job")
        yield put({
            type: ActionTypes.EXECUTE_JOB_FAILURE,
            payload: {
                error: e.message, dataUniqueId: action?.payload?.dataUniqueId
            }
        });
    }
}

export function* watchJobSaga() {
    yield takeEvery(ActionTypes.GET_JOB, getJob);
    yield takeEvery(ActionTypes.SAVE_JOB, saveJob);
    yield takeEvery(ActionTypes.EXECUTE_JOB, executeJob);
}

export default watchJobSaga;